import { MATERIAL_BY_NAME } from '@/lib/planMaterials';

// Rough UK supply & install guide prices — used until the user saves their own price list
const GUIDE = { 'Paving & patio': 95, Driveways: 75, Lawns: 18, Decking: 120, 'Walls & edging': 160, Planting: 35, Structures: 0, Misc: 50 };
const ITEM_GUIDE = { Tree: 250, Shrub: 25, 'Fire pit': 450, 'Hot tub': 0, 'Patio table & chairs': 0 };

export const priceUnit = (name) => {
  const m = MATERIAL_BY_NAME[name] || {};
  if (m.structure || m.tree || m.category === 'Structures') return 'item';
  return m.wall ? 'm' : 'm²';
};

export const guidePrice = (name) => (priceUnit(name) === 'item' ? ITEM_GUIDE[name] ?? 0 : GUIDE[MATERIAL_BY_NAME[name]?.category] ?? 0);

export const priceFor = (user, name) => user?.plan_prices?.[name] ?? guidePrice(name);
